import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { SupportService } from '../../../services/support.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
declare var $: any;

@Component({
  selector: 'app-support-new-advanced-case',
  templateUrl: './support-new-advanced-case.component.html',
  styleUrls: ['./support-new-advanced-case.component.scss']
})
export class SupportNewAdvancedCaseComponent implements OnInit {

    constructor(private route: ActivatedRoute,
        private router: Router, private supportService: SupportService,
        public authentication: AuthenticationService,
        private common: CommonService) {
        debugger;
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        this.getVendorInformation();
                        this.getProductInformation();
                        this.getSupportSeverity();

                        var sfAccountID = this.authentication.userData.sfAccountID;
                        var sfContactId = this.authentication.userData.sfContactId

                        if (sfAccountID && sfAccountID != "" && sfContactId && sfContactId != "") {
                            //
                        }
                        else {
                            //message that the user doesnot have enough privilege to submit new service.
                            this.accessdenied = true;
                        }

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );


        });

    }

    isError: boolean = false;
    errorMessage: string = "";

    supportTypeName: string = "Advanced Support";

    btnSubmitDisabled: boolean = false;
    btnSubmitText: string = "Send";

    //userData: any = {};


    Case: any = {
        CaseObject: {
            RequesterName: "",
            RequesterAccount: "",
            Status: "Open",
            Origin: "Web",
            AccountID: "",
            ContactId: "",
            Subject: "",
            Description: "",
            OS_Vendor__c: "",
            Operating_System_New__c: "",
            Vendor__C: "",
            Product_Category__c: "",
            Product_Sub_Category__c: "",
            Product_Name__c: "",
            Product_Version__c: ""
        }
    };

    formValidation() {
        if (this.Case.CaseObject.Subject === '' ||
            this.Case.CaseObject.Description === '') {
            this.common.ShowMessage('error', 'Case Subject and Description are mandatory', '')
            return false;
        }
        return true;
    }

    submitCaseAttachments(caseId: any) {


        var files = this.files;
        var attachmentsObj = {
            ParentId: caseId,
            attachments: []
        };
        for (var i = 0; i < files.length; i++) {

            var file = files[i];
            var isLastIndex = false;
            if (i == files.length - 1)
                isLastIndex = true;
            this.getFile(file, attachmentsObj, isLastIndex);
        }

    }

    getFile(file: any, attachmentsObj: any, isLastIndex: any) {
        var reader = new FileReader();
        var _self = this;
        reader.onload = function (readerEvt) {

            var binaryString = readerEvt['target']!['result']!.toString().split(',')[1];
            var contentType = file.type;
            if (file.name.toLowerCase().indexOf(".zip") !== -1 && file.type === "")
                contentType = "application/x-zip-compressed";
            attachmentsObj.attachments.push({
                ContentType: contentType,
                Name: file.name,
                Body: binaryString
            });
            if (isLastIndex) {
                var _this = _self;
                _self.supportService.addAttachment(attachmentsObj).subscribe(
                    (res: any) => {
                        _this.btnSubmitText = "Submit";
                        _this.btnSubmitDisabled = false;
                        _this.submitCaseMessage(true, '');
                        //_this.clearCase();
                    },
                    (err: any) => {
                        console.log("addAttachment err", err);
                    }
                );

            }
        };
        reader.readAsDataURL(file);
    }

    submitCaseMessage(isInserted: any, errorMsg: any) {
        var title = '';
        var msg = '';
        var type = '';
        if (isInserted) {
            this.common.ShowMessage('success', 'Your case was successfully submitted (#' + this.addedCaseObj.CaseNumber + ')', '')
            this.router.navigate(['support/support-case-details/' + this.addedCaseObj.Id]);
        }
        else {
            this.common.ShowMessage('error', errorMsg, '');
        }
    }
    addedCaseObj: any = {};
    isSystemDown: boolean = false;
    submitCase() {

        if (this.formValidation()) {
            //validation
            this.btnSubmitText = "Submitting";
            this.btnSubmitDisabled = true;


            if ($('#osVendorSelect').length > 0)
                this.Case.CaseObject.OS_Vendor__c = $('#osVendorSelect')[0].value;

            if ($('#osSelect').length > 0)
                this.Case.CaseObject.Operating_System_New__c = $('#osSelect')[0].value;

            if ($('#productVendorSelect').length > 0)
                this.Case.CaseObject.Vendor__C = $('#productVendorSelect')[0].value;

            if ($('#productMainCategorySelect').length > 0)
                this.Case.CaseObject.Product_Category__c = $('#productMainCategorySelect')[0].value;

            if ($('#productSubCategorySelect').length > 0)
                this.Case.CaseObject.Product_Sub_Category__c = $('#productSubCategorySelect')[0].value;

            if ($('#productSelect').length > 0)
                this.Case.CaseObject.Product_Name__c = $('#productSelect')[0].value;

            if ($('#severitySelect').length > 0)
                this.SelectedSeverity = $('#severitySelect')[0].value;
            else
                this.SelectedSeverity = null;

            this.Case.HtmlBody = "";
            this.supportService.submitSupportCase(this.Case, this.isSystemDown, this.authentication._authentication.id, this.SelectedSeverity, this.supportTypeName).subscribe(
                (res: any) => {

                    if (res.Status) {


                        //this.btnSubmitText = "Submit";
                        //this.btnSubmitDisabled = false;

                        //var Id = res['caseObject'].Id;

                        //this.router.navigate(['/support/support-case-details/' + Id]);

                        this.addedCaseObj = res['caseObject'];
                        if (this.files.length > 0) {
                            this.submitCaseAttachments(res['caseObject'].Id);
                        }
                        else {
                            this.btnSubmitText = "Submit";
                            this.btnSubmitDisabled = false;
                            this.submitCaseMessage(true, '');
                            //this.clearCase();
                        }
                    }
                },
                (err: any) => {
                    this.btnSubmitText = "Submit";
                    this.btnSubmitDisabled = false;
                    console.log("submitSupportCase", err);
                }
            );
        }

    }
    pagecode: string = "supp-submit-adv";
    module: string = "support";
    accessdenied: boolean = false;

    ngOnInit(): void {
    }


    vendorInformation: any[] = [];
    productInformation: any[] = [];

    getVendorInformation() {
        this.supportService.getVendorInformation().subscribe(
            (res: any) => {
                for (var i = 0; i < res.length; i++) {
                    this.vendorInformation.push(res[i]);
                }
                //console.log("this.vendorInformation")
                //console.log(this.vendorInformation);
                if (this.vendorInformation.length > 0) {
                    this.osVendorChanged({
                        target: {
                            value: this.vendorInformation[0].Vendor
                        }
                    });
                }
            },
            (err: any) => {
                console.error("getVendorInformation err", err);
            }
        );
    }


    SelectedSeverity: any;

    operatingSystem: boolean = false;

    OSInformation: any[] = [];

    SelectedOS: any;

    SelectedOSVendor: any;

    osVendorChanged(evt: any) {

        var VendorName = evt.target.value;
        var Vendor = this.vendorInformation.find(s => s.Vendor == VendorName);

        this.SelectedOSVendor = Vendor;

        this.operatingSystem = false;
        if (Vendor != null) {
            this.SelectedOS = {};
            this.OSInformation = [];
            //console.log("evt", evt);
            for (var i = 0; i < Vendor.osItems.length; i++) {
                this.OSInformation.push({ os: Vendor.osItems[i] });
            }

            if (this.OSInformation.length > 0) {
                this.SelectedOS = this.OSInformation[0];
                this.operatingSystem = true;
            }
        }
    }

    severityLevel: any[] = [];

    getSupportSeverity() {
        this.supportService.getSupportSeverity().subscribe(
            (res: any) => {
                if (res.success)
                    this.severityLevel = res.data;
                if (this.severityLevel.length > 0)
                    this.SelectedSeverity = this.severityLevel[0];
            },
            (err: any) => {
                console.error("getSupportSeverity()", err);
            }

        );

    }

    getProductInformation() {
        this.supportService.getProductInformation().subscribe(
            (res: any) => {
                for (var i = 0; i < res.length; i++) {
                    this.productInformation.push(res[i]);
                }
                //console.log("this.productInformation")
                //console.log(this.productInformation)
                if (this.productInformation.length > 0) {
                    this.SelectProductVendor({
                        target: {
                            value: this.productInformation[0].Vendor
                        }
                    });
                }
            },
            (err: any) => {
                console.error("getProductInformation err", err);
            }
        );
    }

    category: boolean = false;
    subcategory: boolean = false;
    product: boolean = false;
    SelectedProductMainCategory: any;
    SelectedProductSubCategory: any;
    SelectedProduct: any;
    productSubCategories: any[] = [];
    products: any[] = [];
    productMainCategories: any[] = [];
    SelectedProductVendor: any;

    SelectProductVendor(evt: any) {


        var productVendorName = evt.target.value;
        var productVendor = this.productInformation.find(s => s.Vendor == productVendorName);

        this.SelectedProductVendor = productVendor;

        this.category = false;
        this.subcategory = false;
        this.product = false;

        if (productVendor.MainCategory != null) {
            this.productMainCategories = productVendor.MainCategory;
            if (this.productMainCategories.length > 0) {
                this.category = true;

                if (this.productMainCategories[0].DetailCategory != null) {
                    this.productSubCategories = this.productMainCategories[0].DetailCategory;
                    if (this.productSubCategories.length > 0) {
                        this.subcategory = true;

                        if (this.productSubCategories[0].Products != null) {
                            this.products = this.productSubCategories[0].Products;
                            if (this.products.length > 0)
                                this.product = true;
                        }
                    }
                }
            }

        }
    }

    selectProductMainCategory(evt: any) {

        var productMainCategoryName = evt.target.value;
        var productMainCategory = this.productMainCategories.find(s => s.MainCategoryName == productMainCategoryName);

        this.SelectedProductMainCategory = productMainCategory;

        this.subcategory = false;
        this.product = false;

        if (productMainCategory.DetailCategory != null) {
            this.productSubCategories = productMainCategory.DetailCategory;
            if (this.productSubCategories.length > 0) {
                this.subcategory = true;

                if (this.productSubCategories[0].Products != null) {
                    this.products = this.productSubCategories[0].Products;
                    if (this.products.length > 0)
                        this.product = true;
                }
            }
        }


    }

    selectProductSubCategory(evt: any) {

        var productSubCategoryName = evt.target.value;
        var productSubCategory = this.productSubCategories.find(s => s.SubCategoryName == productSubCategoryName);

        this.SelectedProductSubCategory = productSubCategory;

        this.product = false;

        if (productSubCategory.Products != null) {
            this.products = productSubCategory.Products;
            if (this.products.length > 0)
                this.product = true;
        }

    }

    files: any = [];
    filesSelect(selectedFiles: any): void {
        for (var i = 0; i < selectedFiles.target.files.length; i++) {
            this.files.push(selectedFiles.target.files[i]);
        }
    }

    removeFile(fileIndex: any) {
        this.files.splice(fileIndex, 1);
    }

}
